import React from 'react';

import { useTranslation } from 'react-i18next';

import { CustomModal, Flex, UiButton } from '@shared/ui';

import { ModalBodyDocumentInfo } from './ModalBodyDocumentInfo/ModalBodyDocumentInfo';
import cls from './ModalDocumentInfo.module.css';
import { ModalInputsDocumentInfo } from './ModalInputsDocumentInfo/ModalInputsDocumentInfo';
import { useModalDocumentInfo } from './useModalDocumentInfo';
import { openModalDocumentType } from '../../Blocks/DocumentationBlock/Components/DocumentSelect/useDocumentSelect';

interface ModalDocumentInfoProps {
    classes?: string;
}

export const ModalDocumentInfo = ({ classes }: ModalDocumentInfoProps) => {
    const {
        modalMode,
        onCancel,
        onExport,
        handleInputChange,
        documentFormInfo,
        handleCheckboxClick,
        selectedEstimates,
        estimates,
        header,
    } = useModalDocumentInfo();

    const { t } = useTranslation();

    return (
        <CustomModal isOpen={!!openModalDocumentType.includes(modalMode)} onHideModal={onCancel}>
            <CustomModal.Header>{header}</CustomModal.Header>
            <CustomModal.Body>
                <ModalBodyDocumentInfo
                    estimates={estimates.estimates}
                    handleCheckboxClick={handleCheckboxClick}
                    selectedEstimates={selectedEstimates}
                />
            </CustomModal.Body>
            <CustomModal.Footer classes={cls.footer}>
                <Flex fullWidth direction="column" gap={24} align="start">
                    <div className={cls.valueEstimate}>
                        {t('ModalBodyDocumentInfo.return.valueEstimates', {
                            estimateValue: Object.values(selectedEstimates).filter(Boolean).length,
                        })}
                    </div>
                    {modalMode !== 'doc_kp' && modalMode !== 'doc_your_proposal' && (
                        <ModalInputsDocumentInfo
                            documentFormInfo={documentFormInfo}
                            onChangeInput={handleInputChange}
                        />
                    )}
                    <Flex fullWidth justify="between">
                        <UiButton
                            onClick={onCancel}
                            btnColor="secondary"
                            btnText={t('ModalDocumentInfo.return.modalFooter.cancel')}
                        />
                        <UiButton
                            onClick={onExport}
                            btnText={t('ModalDocumentInfo.return.modalFooter.save')}
                        />
                    </Flex>
                </Flex>
            </CustomModal.Footer>
        </CustomModal>
    );
};
